module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_photowedding-9a24c63e9fa1368a8150f26e06364d12.webp";